var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    stroke: "#C4CED7",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4CED7",
    d: "M18.5 6a12.5 12.5 0 0 1 0 25V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseHalf);
export default __webpack_public_path__ + "static/media/ellipseHalf.5923f3fe23ade4804fabd6e4647fd89b.svg";
export { ForwardRef as ReactComponent };